export default __webpack_public_path__ + "static/media/circled-chevron-right.a441a74d.svg";